import ActionWrapper from './ActionWrapper';

export default ActionWrapper;
